import React from 'react';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import NoItemResult from '../../../components/results/NoItemResult';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import DashboardLoader from './DashboardLoader';
import DashboardRedirection from './DashboardRedirection';

const DashboardPage = () => {
    const { t } = useTranslation(['dashboard']);

    const company = useCompany(true);

    if (!company) {
        return <NoItemResult subTitle={t('dashboard:noCompanySelected')} />;
    }

    if (!hasPermissions(company.permissions, [permissionKind.viewDashboard])) {
        return <DashboardRedirection />;
    }

    return (
        <ConsolePageWithHeader title={t('dashboard:title')}>
            <DashboardLoader />
        </ConsolePageWithHeader>
    );
};

export default DashboardPage;
